import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Box } from 'rebass/styled-components'

import { MegaphoneIcon } from '../../Icon'
import { MenuTrigger } from '../Menu'
import type { ChangelogEntry } from './index'

const UnreadEntriesBadge = (): JSX.Element => (
  <Box
    as="span"
    data-testid="unread-changelog-badge"
    sx={{
      position: 'absolute',
      top: '1px',
      left: '-2px',
      width: '9px',
      height: '9px',
      backgroundColor: 'green200',
      border: '2px solid',
      borderColor: 'blue500',
      borderRadius: '50%'
    }}
  />
)

interface NavItemProps {
  entries?: ChangelogEntry[]
  changelogViewDate: string
}

export const NavItem = ({ entries, changelogViewDate }: NavItemProps): JSX.Element => {
  const [unreadEntries, setUnreadEntries] = useState(false)
  useEffect(() => {
    if (entries && changelogViewDate) {
      const mostRecentEntryDate = entries[0].created_at
      if (new Date(changelogViewDate) >= new Date(mostRecentEntryDate)) {
        setUnreadEntries(false)
      } else {
        setUnreadEntries(true)
      }
    }
  }, [entries, changelogViewDate])

  const { formatMessage } = useIntl()

  return (
    <MenuTrigger title={formatMessage({ id: 'navigation.links.changelog' })}>
      <Box sx={{ position: 'relative' }}>
        {unreadEntries && <UnreadEntriesBadge />}
        <MegaphoneIcon />
      </Box>
    </MenuTrigger>
  )
}
